module.exports = __webpack_public_path__ + "img/add.e89152d9.png";